<template>
  <div>
    <Form ref="searchForm" inline :label-width="70" class="search-form">
      <Form-item class="first" label="课程类型" v-if="showCatagory">
        <EnumSelect
          type="CourseType"
          :except="exceptTypes"
          selector="select"
          v-model="searchCondition.course_type"
          style="width: 100px"
          clearable
        ></EnumSelect>
      </Form-item>
      <Form-item label="课程分类" v-if="showCatagory">
        <Cascader
          :data="catagoris"
          :change-on-select="true"
          trigger="hover"
          v-model="course_classify_ids"
          style="width: 150px"
        ></Cascader>
      </Form-item>
      <Form-item label="课程名称">
        <Input
          style="width: 150px"
          placeholder="请输入课程名称关键字"
          v-model="searchCondition.keywords"
          clearable
          @keydown.native.prevent.enter="search"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/course/basis/index"
        method="post"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        :selectType="selectType"
        keyField="id"
        :selectedItems="selectedItems"
        keepSelected
        :autoLoadData="false"
        :rowSelectDisabled="rowSelectDisabled"
      >
        <template slot="footer-left">
          <Button
            icon="ios-refresh"
            class="btn-margin-right"
            type="text"
            @click="search(1)"
            style="margin-left: 5px"
            >刷新</Button
          >
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
import * as enums from "../../utils/enums";

export default {
  name: "CourseSelect",
  data() {
    return {
      columns: [
        {
          title: "课程名称",
          key: "title",
        },
      ],
      selectList: [],
      searchCondition: {
        keywords: "",
        course_classify_id: 0,
        course_type: this.course_type,
        not_include_system_course: this.not_include_system_course,
        not_include_public_course: this.not_include_public_course,
        spell_group: this.spellGroup,
        integral_shop: this.integralShop,
        recommend: this.recommend,
      },
      catagoris: [],
      course_classify_ids: [],
    };
  },
  props: {
    selectedItems: {
      type: Array,
    },
    selectType: {
      type: String,
      default: "multi",
    },
    status: {
      type: Number,
    },
    vip_type: {
      type: Number,
      default: 0,
    },
    is_divide_class: {
      default: "",
    },
    is_include_system_course: {
      default: "",
    },
    not_include_system_course: {
      default: 0,
    },
    not_include_public_course: {
      default: 0,
    },
    showCatagory: {
      type: Boolean,
      default: false,
    },
    showStatus: {
      type: Boolean,
      default: true,
    },
    spellGroup: {
      default: 0,
    },
    rowSelectDisabled: {
      type: Function,
    },
    showPrice: {
      type: Boolean,
      default: false,
    },
    exceptTypes: {
      type: Array,
      default: () => {
        return ["4"];
      },
    },
    integralShop: {
      type: Number,
      default: 0,
    },
    course_type: {
      default: "",
    },
    recommend: {
      default: 0,
    },
  },
  async created() {
    if (this.showPrice) {
      this.columns.push({ title: "价格", key: "price_str" });
    }
    this.columns.push({
      title: "课程类型",
      key: "course_type_name",
    });
    if (this.showCatagory) {
      this.columns.push({ title: "课程分类", key: "classify_title" });
    }
    if (this.showStatus) {
      this.columns.push({
        title: "上架状态",
        key: "status_name",
        width: 100,
        align: "center",
      });
    }
    let catagoris = await this.$http.get("/api/course/classify");
    catagoris = catagoris.filter((c) => c.children && c.children.length > 0);
    this.catagoris = catagoris;

    if (this.status !== undefined) {
      this.searchCondition.status = this.status;
    }
    this.searchCondition.is_divide_group = this.is_divide_class;
    this.searchCondition.vip_type = this.vip_type;
    this.searchCondition.is_include_system_course =
      this.is_include_system_course;
    this.$refs.grid.searchRefresh();
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach((i) => {
        i.course_type_name = enums.CouseType.getValue(i.course_type);
        i.status_name = enums.CourseStatus.getValue(i.status);
        i.price_str = "¥" + i.price / 100;
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.keywords = "";
        this.searchCondition.course_classify_id = "";
        this.course_classify_ids = [];
        this.searchCondition.course_type = "";
      } else {
        if (this.course_classify_ids.length > 0) {
          this.searchCondition.course_classify_id =
            this.course_classify_ids[this.course_classify_ids.length - 1];
        } else {
          this.searchCondition.course_classify_id = 0;
        }
      }
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(val) {
      this.selectList = [...val];
      this.$emit("onSelectionChange", this.selectList);
    },
    getSelectList() {
      return this.selectList;
    },
    recoverSelectedItems(selectedItems) {
      this.$refs.grid.recoverSelectedItems(selectedItems);
    },
    refresh() {
      this.$refs.grid.refresh();
    },
  },
};
</script>
<style lang="scss" scoped></style>
